<template>
  <div ref="popperParent" class="trigger" @click.stop="clickHandler" :title="title" :class="$props.class">
    <slot  name="trigger"></slot>
  </div>
  <teleport :disabled="!toBody && !inModalWindow" to="body">
    <Transition name="fade" mode="out-in" appear>
      <Popup ref="popperContent" v-if="showProxy" :parent="popperParent" v-bind="$attrs" @keydown.esc="showProxy = false">
        <slot name="content" :close="close"></slot>
      </Popup>
    </Transition>
  </teleport>
</template>

<script>
import { containsElement } from "../../utils/getRootElementsFromComponent";
import Popup from "./Popup.vue";
import { shallowRef, onMounted, onUnmounted, computed, inject } from "vue";

export default {
  inheritAttrs: false,
  components: {
    Popup
  },
  props:{
    show: { type: Boolean, default: undefined },
    toBody: { type: Boolean },
    title: String,
    class: String
  },
  emits:["update:show"],
  setup(props, { slots, emit }){
    const popperParent = shallowRef();
    const popperContent = shallowRef();
    const showPopup = shallowRef(false);
    const inModalWindow = inject("inModalWindow", false);

    // computed, damit man das show-Prop auch weg lassen kann
    const showProxy = computed({
      set(value) {
        if (props.show === undefined) {
          showPopup.value = value ?? !showPopup.value;
        }
        else {
          emit("update:show", value ?? !props.show);
        }
      },
      get() {
        return props.show ?? showPopup.value;
      }
    });
    

    function clickOut(event) {
      const actualTargetElement = event.composedPath()[0]
      
      if(!containsElement(popperContent.value, actualTargetElement) && !containsElement(popperParent.value, actualTargetElement)){
        showProxy.value = false;
      }
    }

    onMounted(()=>{
      window.addEventListener("click", clickOut);
      window.addEventListener("scroll", clickOut, { capture: true, passive: true });
    });

    onUnmounted(()=>{
      window.removeEventListener("click", clickOut);
      window.removeEventListener("scroll", clickOut);
    });
    return {
      popperContent,
      popperParent,
      showPopup,
      inModalWindow,
      clickHandler: (e) => {
        showProxy.value = !showProxy.value;
      },
      showProxy,
      close() {
        showProxy.value = false;
      }
    }
  }
}
</script>

<style scoped="true">
  .trigger {
    display: inline-block;
  }

</style>